import React from "react";
import { useKotCoachRound } from "../hooks/useKotCoachRound";
import {
  KotCoachStartRoundBanner,
  KotCoachStartRoundButton,
} from "./KotCoachStartRoundBanner";
import "./KotCoachStartRound.css";

/**
 * Drop-in coach start-round controls for TableSetup cards or other surfaces.
 */
export function KotCoachStartRoundSlot({
  socket = null,
  teId = null,
  tsId = null,
  exerciseStateId = null,
  enabled = true,
  compact = false,
  /** Header slot: button only (progress stays in exercise panel). */
  buttonOnly = false,
  className = "",
}) {
  const coach = useKotCoachRound({
    socket,
    teId,
    tsId,
    exerciseStateId,
    enabled: enabled && !!socket && !!teId && !!tsId,
  });

  if (buttonOnly) {
    if (!coach.awaitingCoachStart) return null;
    return (
      <div
        className={className || "kot-coach-start-slot--header"}
        onClick={(e) => e.stopPropagation()}
      >
        <KotCoachStartRoundButton
          canStartRound={coach.canStartRound}
          awaitingCoachStart={coach.awaitingCoachStart}
          preparingNextRound={coach.preparingNextRound}
          roundNumber={coach.roundNumber}
          starting={coach.startingRound}
          onStart={coach.startNextRound}
        />
      </div>
    );
  }

  if (
    !coach.awaitingCoachStart &&
    !coach.showSubmissionProgress &&
    !coach.roundClosing &&
    !coach.startError
  ) {
    return null;
  }

  return (
    <div className={className || undefined} onClick={(e) => e.stopPropagation()}>
      <KotCoachStartRoundBanner
        compact={compact}
        canStartRound={coach.canStartRound}
        awaitingCoachStart={coach.awaitingCoachStart}
        preparingNextRound={coach.preparingNextRound}
        roundClosing={coach.roundClosing}
        showSubmissionProgress={coach.showSubmissionProgress}
        submissionSummary={coach.submissionSummary}
        roundNumber={coach.roundNumber}
        starting={coach.startingRound}
        startError={coach.startError}
        onStart={coach.startNextRound}
        onDismissError={coach.clearStartError}
        rotationMoves={coach.snapshot?.rotation}
      />
    </div>
  );
}

export default KotCoachStartRoundSlot;
